import type { CookieService } from "@/src/infrastructure/cookie-consent/CookieService";

export const airtableCookie: CookieService = {
  iframe: {
    embedUrl: "https://airtable.com/embed/{data-id}/form",
  },
  name: "Airtable",
  service: {
    label: "<strong>Airtable</strong> : inscription aux événements",
  },
};
